import * as log from 'loglevel';
import AxiosAPI from './AxiosAPI';

class Search extends AxiosAPI {
  loadPresearch() {
    return new Promise((resolve, reject) => {
      super.getList('v1/presearch').then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  searchData(query, offset, limit, content) {
    return new Promise((resolve, reject) => {
      super.getList('v1/search', {
        q: query, maxResults: limit, offset, content,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  typeAheadSearch(query, limit) {
    return new Promise((resolve, reject) => {
      super.getList('v1/typeahead', { q: query, maxResults: limit })
        .then((resp) => {
          resolve(resp || []);
        })
        .catch((error) => {
          log.info(`Error in typeAheadSearch in Search.js Service: ${error && error.message}`);
          reject();
        });
    });
  }

  getRecentSearches() {
    return new Promise((resolve, reject) => {
      super.getList('v1/user/recent_searches')
        .then((resp) => {
          resolve(resp || []);
        })
        .catch((error) => {
          log.warn(`Error in getRecentSearches in Search.js Service: ${error.message}`);
          reject();
        });
    });
  }

  saveRecentSearch(query) {
    return new Promise((resolve, reject) => {
      super.post('v1/user/recent_searches', { keyword: query })
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          log.warn(error.message);
          reject(error);
        });
    });
  }

  deleteRecentSearch(keyword) {
    return new Promise((resolve, reject) => {
      super.delete(`v1/user/recent_searches/${keyword}`)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  deleteAllRecentSearches() {
    return new Promise((resolve, reject) => {
      super.delete('v1/user/recent_searches/clear_all', { force: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default Search;



// WEBPACK FOOTER //
// ./app/src/services/Search.js